import PlayVideo from 'core/assets/icons/video/play_video.svg';
import Icon from "core/assets/icons";
import { getYouTubeThumbnail, handleMapShortContent } from "core/utils/helper";
import Image from "core/components/Image";

const sortItemsByType = (items: any[]) => {
  const videos = items.filter((item: any) => item?.mime_type.includes('video'));
  const images = items.filter((item: any) => item?.mime_type.includes('image'));
  return [...videos, ...images];
}

export default function PostShared({ postType, post, isRemove = true, onRemovePost, handleClick }: any) {
  let imageUrl = '';
  let isVideo = false;
  let name = '';
  let description = '';

  if (postType === 'recipe') {
    isVideo = true;
    imageUrl = getYouTubeThumbnail(post?.video_id);
    name = post?.name
    description = post?.content?.description || post?.content
  }
  if (postType === 'community') {
    if (post?.files && post.files?.length) {
      const _files = sortItemsByType(post?.files);
      imageUrl = _files[0]?.url?.thumbnail || '';
      if (_files[0]?.mime_type.includes('video')) {
        isVideo = true;
      }
    } else {
      if (post?.content?.video_id) {
        isVideo = true;
        imageUrl = getYouTubeThumbnail(post?.content?.video_id);
      }
    }
    description = handleMapShortContent(post, 150)
  }

  const _handleClick = () => {
    post.typePost = postType
    handleClick?.(post)
  }

  return (
    <div className="flex p-3 bg-gray-100 rounded-md shadow w-full" onClick={_handleClick}>
      {imageUrl ? <div className="relative min-w-[103px] h-full mr-[6px]">
        <Image
          src={imageUrl}
          alt="Video thumbnail"
          className="w-[103px] rounded-md object-cover"
        />
        {isVideo && (
          <span className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2">
            <img src={PlayVideo} alt={''} />
          </span>
        )}
      </div> : null}
      <div className="space-y-[6px] tracking-tighter flex-1">
        {name && <p className="text-[13px] font-semibold">
          {name}
        </p>}
        {description && <div
          className={`text-[13px] text-[#333333] ${postType === 'recipe' ? 'line-clamp-3' : ''}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />}
      </div>
      {isRemove && <div className="min-w-[24px]" onClick={onRemovePost}>
        <img className="w-[24px] h-[24px]" src={Icon.Close} alt={'Close'} />
      </div>}
    </div>
  );
}
